import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  DashboardDetailsArrayModel,
  DashboardDetailsModel,
} from "../../models/DashboardDetailsModel";

const initialDashboardDetailsState: DashboardDetailsArrayModel = {
  particular_DashboardDetail: [
    {
      csgo: "",
      csgoHead: "",
      sbg: "",
      sbgHead: "",
      sbu: "",
      sbuHead: "",
      bu: "",
      bdHead: "",
      bdpoc: "",
      projectName: "",
      projectID: 0,
      projectStatus: "",
      estimatedValue: 0,
      bidSubmittedStatusDate: new Date()
    },
  ],
  isFetching: false
};
const DashboardDetailsSlice = createSlice({
  name: "DashboardDetails",
  initialState: initialDashboardDetailsState,
  reducers: {
    setParticularDashboardDetails(
      state,
      action: PayloadAction<DashboardDetailsModel[]>
    ) {
      state.particular_DashboardDetail = action.payload;
    },
    setDashboardDetailsFetching(state, action: PayloadAction<boolean>) {
      state.isFetching = action.payload;
    },
  },
});
export default DashboardDetailsSlice;
